#import "../fragments/stageset-basic.graphql"

query StagesetsForPipelineList {
    stagesets(includeArchived: true) {
        ...StagesetBasic
    }
}
